import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=573c2192&scoped=true&"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=573c2192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c2192",
  null
  
)

export default component.exports